import { LogoutOutlined } from '@ant-design/icons';
import { useLogout } from '@refinedev/core';
import { Button, Divider, Flex, Switch, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import { useUserContext } from '@/contexts/UserContext';
import { UserWorkAreaString } from '@/model/General/UserWorkArea';

import LanguageSegmented from './LanguageSegmented';
import ThemeSegmented from './ThemeSegmented';

const UserMenuContent = () => {
  const { t } = useTranslation();
  const { mutate: logout } = useLogout();
  const { devOptions } = useUserContext();
  // Reutilizamos el mismo release que reporta Sentry para mostrar la version cargada en la UI.
  const sentryRelease = import.meta.env.VITE_SENTRY_RELEASE?.trim();
  // Si el release es un SHA completo, mostramos una version corta como referencia visual similar a GitLab.
  const sentryReleaseDisplay =
    sentryRelease && /^[0-9a-f]{40}$/i.test(sentryRelease)
      ? sentryRelease.slice(0, 8)
      : sentryRelease;

  return (
    <Flex vertical gap={6}>
      <Divider orientation="left" plain style={{ margin: '8px 0 2px' }}>
        {t('Lenguaje')}
      </Divider>
      <LanguageSegmented />

      <Divider orientation="left" plain style={{ margin: '8px 0 2px' }}>
        {t('Tema')}
      </Divider>
      <ThemeSegmented />

      {devOptions && (
        <>
          <Divider orientation="left" plain style={{ margin: '8px 0 2px' }}>
            <Typography.Text type="warning">{t('Opciones de desarrollo')}</Typography.Text>
          </Divider>
          <Flex style={{ padding: '4px 0' }} align="center" gap={8}>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {t('Área de trabajo')}:
            </Typography.Text>
            <AntdSelect
              value={devOptions.selectedWorkArea}
              onChange={devOptions.handleChangeWorkArea}
              options={Object.keys(UserWorkAreaString).map(v => ({
                label: UserWorkAreaString[v as keyof typeof UserWorkAreaString],
                value: v,
              }))}
              placeholder={t('Área de trabajo')}
              style={{ width: '50%' }}
            />
          </Flex>

          <Flex align="center" style={{ padding: '4px 0' }} gap={8}>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {t('Cambio de país')}
            </Typography.Text>
            <Switch
              checked={devOptions.canChangeCountry}
              onChange={devOptions.handleToggleCanChangeCountry}
            />
          </Flex>
        </>
      )}

      <Divider style={{ margin: '8px 0 2px' }} />

      <Button type="text" onClick={() => logout()} icon={<LogoutOutlined />}>
        {t('Cerrar sesión')}
      </Button>

      <div className="LayoutHeaderReleaseTag" title={sentryRelease}>
        {t('Release')}: {sentryReleaseDisplay ? sentryReleaseDisplay : 'Local'}
      </div>
    </Flex>
  );
};

export default UserMenuContent;
